import { api } from "@/lib/api";

export interface HealthStatus {
    api: "healthy" | "unhealthy";
    database: "healthy" | "unhealthy";
    redis: "healthy" | "unhealthy";
}

export const systemService = {
    checkHealth: async () => {
        try {
            const response = await api.get<HealthStatus>("/api/health/full");
            return response.data;
        } catch (error) {
            return {
                api: "unhealthy",
                database: "unhealthy",
                redis: "unhealthy",
            } as HealthStatus;
        }
    },
};
